import { Card, CardContent } from '@/components/ui/card';
import { SITE_CONFIG } from '@/lib/constants';

/**
 * Terms of Service page
 */
export function Terms() {
  const lastUpdated = '16/12/2025';

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <span className="category-label">Legal</span>
          <h1 className="text-4xl font-bold">Terms of Service</h1>
          <p className="mt-4 text-muted-foreground">
            Last updated: {lastUpdated}
          </p>

          <Card className="mt-8">
            <CardContent className="prose prose-invert max-w-none p-6 md:p-8">
              <div className="space-y-8">
                <section>
                  <h2 className="text-xl font-semibold text-foreground">1. Agreement to Terms</h2>
                  <p className="mt-2 text-muted-foreground">
                    By accessing or using the services provided by {SITE_CONFIG.name},
                    you agree to be bound by these Terms of Service. If you do not agree
                    to these terms, please do not use our services.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">2. Services Offered</h2>
                  <p className="mt-2 text-muted-foreground">
                    We offer the following services:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>Gardening services (lawn care, hedge trimming, garden maintenance)</li>
                    <li>Cleaning services (residential and commercial cleaning)</li>
                    <li>Taxidermy services (preservation and mounting of specimens)</li>
                  </ul>
                  <p className="mt-4 text-muted-foreground">
                    All services are subject to availability and may be modified or
                    discontinued at our discretion.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">3. Bookings and Cancellations</h2>
                  <p className="mt-2 text-muted-foreground">
                    Service bookings require confirmation from both parties. Cancellations
                    should be made at least 24 hours in advance where possible. Late
                    cancellations or no-shows may be subject to a cancellation fee at
                    our discretion.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">4. Payment Terms</h2>
                  <p className="mt-2 text-muted-foreground">
                    Prices are provided upon request and are tailored to each job's
                    specific requirements. Payment terms will be agreed upon before
                    work commences. For taxidermy services, a deposit may be required.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">5. Liability Limitations</h2>
                  <p className="mt-2 text-muted-foreground">
                    While we strive to deliver quality services, we are not liable for:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>Pre-existing damage or conditions not disclosed before service</li>
                    <li>Results affected by factors beyond our control</li>
                    <li>Consequential or indirect damages</li>
                    <li>Natural deterioration of taxidermy specimens over time</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">6. Taxidermy-Specific Terms</h2>
                  <p className="mt-2 text-muted-foreground">
                    For taxidermy services specifically:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>Clients must ensure specimens are legally obtained</li>
                    <li>We may decline work on protected species without proper permits</li>
                    <li>Timeframes vary based on complexity and may be extended</li>
                    <li>Clients are responsible for shipping permits (see Shipping Policy)</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">7. Dispute Resolution</h2>
                  <p className="mt-2 text-muted-foreground">
                    Any disputes arising from our services should first be raised directly
                    with us. We are committed to resolving issues fairly and promptly.
                    If a dispute cannot be resolved informally, it will be subject to
                    the laws of Tasmania, Australia.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">8. Changes to Terms</h2>
                  <p className="mt-2 text-muted-foreground">
                    We reserve the right to update these Terms of Service at any time.
                    Continued use of our services after changes constitutes acceptance
                    of the new terms.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">9. Contact</h2>
                  <p className="mt-2 text-muted-foreground">
                    For questions about these terms, contact us at{' '}
                    <a
                      href={`mailto:${SITE_CONFIG.contact.email}`}
                      className="text-primary hover:underline"
                    >
                      {SITE_CONFIG.contact.email}
                    </a>
                    .
                  </p>
                </section>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
